import { Component, Input } from '@angular/core';
import {
  ControlContainer,
  ControlValueAccessor,
  NG_VALUE_ACCESSOR,
} from '@angular/forms';
import { UserDao } from '@app/dao/user/user.dao';
import { combineLatest } from 'rxjs';

@Component({
    selector: 'pr-input-owner',
    templateUrl: './pr-input-owner.component.html',
    styleUrls: ['./pr-input-owner.component.scss'],
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            multi: true,
            useExisting: PrInputOwnerComponent,
        },
    ],
    standalone: false
})
export class PrInputOwnerComponent implements ControlValueAccessor {
  @Input() formControlName: string;
  @Input() derrors: boolean = false;
  @Input() multiple: boolean = true;
  @Input() tooltipButton: string;
  options: Array<{ ids: Number[]; label: string }> = [];

  values: Number[] = [];
  touched = false;
  disabled = false;
  onChange = values => {};
  onTouched = () => {};

  constructor(
    private userDao: UserDao,
    private controlContainer: ControlContainer,
  ) {}

  get control() {
    return this.controlContainer.control.get(this.formControlName);
  }

  ngOnInit() {
    combineLatest([
      this.userDao.getCouple(),
      this.userDao.getOwners(),
    ]).subscribe(([couple, owners]) => {
      let leftowners = [...owners];
      for (let user of couple) {
        let owner = leftowners.find(o => o.id == user.id);
        leftowners = leftowners.filter(o => o !== owner);
        this.options.push({
          ids: this.multiple ? [owner.id] : owner.id,
          label: owner.label,
        });
      }
      if (couple.length > 1 && this.multiple === true) {
        let ids = couple.map(user => user.id);
        this.options.push({ ids: ids, label: 'En commun' });
      }
      for (let owner of leftowners) {
        this.options.push({
          ids: this.multiple ? [owner.id] : owner.id,
          label: owner.label,
        });
      }
    });
  }

  onInputChange($event) {
    this.values = $event.value;
    this.onChange(this.values);
  }

  writeValue(values: Number[]): void {
    this.values = values;
  }

  registerOnChange(onChange: any): void {
    this.onChange = onChange;
  }

  registerOnTouched(onTouched: any): void {
    this.onTouched = onTouched;
  }

  markAsTouched() {
    if (!this.touched) {
      this.onTouched();
      this.touched = true;
    }
  }

  setDisabledState(isDisabled: boolean): void {
    this.disabled = isDisabled;
  }

  compareFn(a, b): boolean {
    if (a === b) return true;
    if (a == null || b == null) return false;
    if (a.length !== b.length) return false;

    for (let item of a) {
      if (b.indexOf(item) < 0) return false;
    }
    return true;
  }
}
